import { render, staticRenderFns } from "./System_log.vue?vue&type=template&id=710ec945&"
import script from "./System_log.vue?vue&type=script&lang=js&"
export * from "./System_log.vue?vue&type=script&lang=js&"
import style0 from "./System_log.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports